import { ThemedStyleFn } from '~src/hooks/useStyles';
import { fadeInKeyframes } from '~src/styles/animations';

export const styleFn: ThemedStyleFn = (theme) => ({
  alignCenterWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 20px',
  },
  table: {
    '.ant-table-row': {
      animation: `${fadeInKeyframes} 0.3s ease-out`,
      cursor: 'pointer',

      '&.unfinished > td': {
        color: 'rgba(0, 0, 0, 0.25)',
      },
    },
    // Ensure table body doesn't overflow
    '.ant-table-body': {
      overflowY: 'auto',
      overflowX: 'auto',
    },
  },

  underTableWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0px',
    position: 'relative',
    zIndex: 2,
    flexShrink: 0,
    minHeight: '50px',
  },
  panelsContainer: {
    position: 'relative',
    width: '100%',
    flexShrink: 0,
  },

  printContainer: {
    '@media print': {
      paddingBottom: '0.01cm',
    },
  },

  printTable: {
    '.ant-table': {
      fontSize: '13px',
      borderCollapse: 'collapse',
      pageBreakInside: 'avoid',
      pageBreakAfter: 'avoid',
      breakInside: 'avoid',
    },

    '.ant-table-tbody > tr': {
      pageBreakInside: 'avoid',
      pageBreakAfter: 'avoid',
      breakInside: 'avoid',
    },

    '.ant-table-tbody > .ant-table-expanded-row': {
      borderBottom: '50px solid transparent',
      pageBreakAfter: 'auto',
      pageBreakInside: 'avoid',
      breakInside: 'avoid',
    },

    '.ant-table-thead > tr > th': {
      backgroundColor: '#f8f8f8',
      padding: '50px 16px 12px 16px',
      fontWeight: 600,
      fontSize: '14px',
      borderBottom: '1px solid #ddd',
      pageBreakInside: 'avoid',
      pageBreakAfter: 'avoid',
      breakInside: 'avoid',
    },

    '.ant-table-tbody > tr > td': {
      padding: '50px 16px 12px 16px',
      borderBottom: '1px solid #eee',
      pageBreakInside: 'avoid',
      pageBreakAfter: 'avoid',
      breakInside: 'avoid',
    },

    '.ant-table-tbody > tr:nth-of-type(odd) > td': {
      backgroundColor: '#e7e7e7',
      pageBreakInside: 'avoid',
      pageBreakAfter: 'avoid',
      breakInside: 'avoid',
    },

    '.ant-table-tbody > tr:nth-of-type(even) > td': {
      backgroundColor: '#fff',
      padding: '0px 0px',
      borderBottom: '1px solid black',
      pageBreakInside: 'avoid',
      pageBreakAfter: 'avoid',
      breakInside: 'avoid',
    },

    '@media print': {
      '&': {
        marginBottom: '0.5cm',
        paddingBottom: '0.3cm',
      },

      '.ant-table': {
        marginBottom: '0.2cm',
      },
    },
  },
});
